// extracted by mini-css-extract-plugin
export default {"wrapper":"CreatePropertyInfo_wrapper__t-kW3","col":"CreatePropertyInfo_col__ExxZY"};